<script>
  import { ExternalLink, MapPin } from 'lucide-svelte';

  export let payload = null;
  export let fallback = '';
  export let mobile = false;

  $: displayFallback =
    typeof fallback === 'string' && fallback.trim() ? fallback : 'Không thể hiển thị vị trí';
</script>

{#if payload}
  <div class:location-card--mobile={mobile} class="location-card">
    <div class="location-card__icon"><MapPin size={21} strokeWidth={2.2} /></div>
    <div class="location-card__body">
      <strong>{payload.label}</strong>
      <span>{payload.lat.toFixed(6)}, {payload.lng.toFixed(6)}</span>
      {#if payload.accuracy !== null}
        <span>Chính xác khoảng {Math.round(payload.accuracy)} m</span>
      {/if}
      <a href={payload.mapUrl} target="_blank" rel="noopener noreferrer">
        Mở Google Maps <ExternalLink size={13} />
      </a>
    </div>
  </div>
{:else}
  <p class="location-fallback">{displayFallback}</p>
{/if}

<style>
  .location-card {
    display: flex;
    gap: 0.75rem;
    width: min(19rem, 68vw);
    padding: 0.2rem 0;
  }

  .location-card--mobile {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    align-items: start;
    width: min(19rem, 100%);
  }

  .location-card__icon {
    display: grid;
    flex: 0 0 auto;
    place-items: center;
    width: 2.6rem;
    height: 2.6rem;
    border-radius: 0.85rem;
    color: #dc2626;
    background: rgba(254, 226, 226, 0.92);
  }

  .location-card__body {
    display: grid;
    min-width: 0;
    gap: 0.2rem;
  }

  .location-card__body strong {
    color: #0f172a;
    font-size: 0.88rem;
  }

  .location-card__body span {
    color: #64748b;
    font-size: 0.72rem;
  }

  .location-card__body a {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    width: fit-content;
    margin-top: 0.18rem;
    color: #075ecc;
    font-size: 0.75rem;
    font-weight: 650;
  }

  .location-card__body a:hover {
    text-decoration: underline;
  }

  .location-fallback {
    color: #64748b;
    font-size: 0.8rem;
  }

  .location-card--mobile .location-card__body {
    gap: 0.15rem;
  }

  .location-card--mobile .location-card__body strong {
    font-size: 0.95rem;
  }

  .location-card--mobile .location-card__body span {
    font-size: 0.75rem;
    line-height: 1.25;
  }
</style>
